import styled, { css } from 'styled-components'

type OverlayProps = {
  isOpen: boolean
}

export const Overlay = styled.div<OverlayProps>`
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 9999;

  ${({ isOpen }) =>
    isOpen
      ? css`
          opacity: 1;
          pointer-events: auto;
          transition: opacity 0.3s ease-in-out;
        `
      : css`
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease-in-out;
        `}
`

Overlay.displayName = 'Overlay'

export const Header = styled.header`
  min-height: 3.75rem;
  padding: 1.125rem;
  background-color: var(--gray-100);
  top: 0;
`

Header.displayName = 'Header'

export const Content = styled.div`
  background-color: var(--gray-100);
  max-width: 90vw;
  max-height: 90vh;

  img,
  video,
  iframe {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  > div {
    width: 90vw !important;
  }
`

Content.displayName = 'Content'

export const CloseButton = styled.button`
  cursor: pointer;
`

CloseButton.displayName = 'CloseButton'
